<template>
  <b-container fluid class="container container-vende-tu-auto">

    <div v-if="this.tipoAgendamiento === 'agendamiento'" class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center ">
        <img class="step-desktop" src="../assets/imgs/desktop/desktop-VTA-valoracion-agendada.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/tablet-VTA-VALORACION-AGENDADA.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/MOBILE-VTA-VALORACION-AGENDADA.png" alt="AUTOCOM" />
      </div>

      <div v-if="this.tipoAgendamiento === 'reagendamiento'" class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center ">
        <img class="step-desktop" src="../assets/imgs/desktop/desktop-VTA-valoracion-reagendada.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/tablet-VTA-VALORACION-REAGENDADA.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/MOBILE-VTA-VALORACION-REAGENDADA.png" alt="AUTOCOM" />
      </div>
    
    <div class="row justify-content-center">
      <div class="col-sm-12 text-center">
      </div>

      <div class="container container-info" >
        <div class="container-vende-view">
      <div class="content-va">

      <div class="col-md-12 text-center margin-inspeccion">

        <p v-if="this.tipoInspeccion === 'domicilio'" class="mb-5 texto-felicitacion">
          ¡Felicidades {{nombre}}! <br>
          <span >La inspección ha sido solicitada,</span><br> en breve uno de nuestros
          asesores te contactará para confirmar la visita.
        </p>
        
        <p v-if="this.tipoInspeccion !== 'domicilio'" class="mb-5 texto-felicitacion">
          ¡Felicidades {{nombre}}! <br>
          <span >La inspección en agencia ha sido agendada,</span> <br/> recibirás un mail de confirmación con los detalles.
        </p>

        <div class=" marcaModeloAño text-uppercase">{{ año }} <span class="black">{{ marca.toUpperCase() }} {{ modelo.toUpperCase() }}</span></div>
        <div class="versionColorKm mb-2 text-uppercase">{{ version }} <span class="pipe">|</span> {{ color }} <span class="pipe">|</span> {{ kilometraje }} KM</div>
        <div class="titulo-mobile nofolio mb-4">
          <h4 class="titulo-nofolio">NO. DE OFERTA: {{ this.folioMail }}</h4>
          <h4 class="titulo-nofolio marginTop-folio">NO. DE INSPECCIÓN AGENDADA: {{ this.folio }}</h4>
          
      </div>

        <div class="mejorOfertaMobile border-mejor-oferta">
          <h4 class="mejor-oferta">EL RANGO DE TU <br> MEJOR OFERTA <b>GARANTIZADA</b> ES</h4>
            <b-col>
              <h5 class="oferta"> <span class="ofertaLight">DE</span> ${{ formatPrice(formatValue(this.ofertaMin)) }}.00* <span class="ofertaLight">A</span> ${{ formatPrice(formatValue(this.ofertaMax)) }}.00*</h5>
            </b-col>
        </div>

          <p class="texto-oferta mt-3">
              Esta oferta es válida hasta el <span class="fecha-ispeccion2">{{ this.validezVA }}</span><br />*El monto de la oferta puede variar después
              de la inspección del vehículo
          </p>



        <div v-if="this.tipoInspeccion !== 'domicilio'" class="row justify-content-md-center">
          <div class="row col-12">
            <div class="col-6 right-2"><h3 class="mb-0 info-cita">Fecha:</h3></div>
            <div class="col-6 left-2"><h3 class="mb-0 info-cita-2" >{{this.fecha}}</h3></div>
            <div class="col-6 right-2"><h3 class="mb-0 info-cita">Hora:</h3></div>
            <div class="col-6 left-2"><h3 class="mb-0 info-cita-2" >{{this.hora}} hrs.</h3></div>
            <div class="col-6 right-2"><h3 class="mb-0 info-cita">Lugar de inspección:</h3></div>
            <div class="col-6 left-2"><h3 class="mb-0 info-cita-2" >{{this.agencia}} <br> {{this.domicilio}}</h3></div>
          </div>
        </div>

        <div v-if="this.tipoInspeccion === 'domicilio'" class="row col-12">
          <div class="col-6 right-2">
            <h3 class="info-cita">Domicilio donde te visitaremos:</h3>
          </div>
          <div class="col-6 left-2">
            <h3 class="info-cita-2"><span>{{this.domicilio}}</span></h3>            
          </div>
        </div>

        <p class="texto-oferta mt-5">
          Si quieres modificar la cita para la inspección <a  class="enlace" @click="prueba()">haz clic aquí</a>
        </p>

        <!--p class="texto-oferta mt-2">
          Conoce los documentos que necesitas para vender tu auto, <a  class="enlace" @click="documentacion()">haz clic aquí</a>
        </p-->

        <p v-if="this.token!==null && this.tipoInspeccion !== 'domicilio'" class="call-to-action">¡Vende más rápido!</p>

        <p v-if="this.token!==null && this.tipoInspeccion !== 'domicilio'" class="p-call-to-action">Compártenos los documentos que necesitaremos previo a la revisión de tu auto <a class="a-call-to-action" target="_top" :href="'https://expediente.autocom.mx?expediente='+this.expediente+'&token='+this.token+'&src=va'">haz clic
          aquí</a></p>
        

        <div class="text-center mt-3 print">
              <a href="javascript:window.print()"><img src="../assets/imgs/ico-print.svg" class="imgImp"  fluid><span class="text-imprimir"> Imprimir confirmación </span></a>
        </div>        

        <div class="text-center">
          <button class="-btn-continuar btn-a-domicilio" @click.prevent="paginaPrincipal()">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>
      </div>
    </div>
    </div></div>
    </div>
  </b-container>
</template>

<script>

export default {
  name: "Inspeccion",

  components: {},

  data() {
    return {
      user: sessionStorage.getItem("nombreUsuario"),
      //server: 'https://qa-api-analizador.autocom.mx/api',

      /*server: 'https://api-autocheck.autocom.mx/api',*/
      server: process.env.VUE_APP_SERVER_AUTOCHECK,


      expediente:sessionStorage.getItem("expediente"),
      token:sessionStorage.getItem("tokenExpediente"),
      urlExpediente:'',

      nombre: sessionStorage.getItem("nombre"),
      apellidos: sessionStorage.getItem("apellidos"),
      marca: sessionStorage.getItem("marca"),
      modelo: sessionStorage.getItem("modelo"),
      año: sessionStorage.getItem("anio"),
      version: sessionStorage.getItem("version"),
      color: sessionStorage.getItem("color"),
      kilometraje: sessionStorage.getItem("kilometraje"),

      oferta: sessionStorage.getItem("oferta"),
      ofertaMin: '',
      ofertaMax: '',
      folio: sessionStorage.getItem("idvaloration"),
      folioMail: sessionStorage.getItem("folio"),
      agencia: sessionStorage.getItem("sucursalAgenda"),
      fecha: sessionStorage.getItem("fechaAgenda"),
      hora: sessionStorage.getItem("horaAgenda"),
      domicilio: sessionStorage.getItem("direccionAgencia"),
      tipoInspeccion: sessionStorage.getItem("tipoInspeccion"),
      validezVA: sessionStorage.getItem("fecha_validez"),
      tipoAgendamiento: sessionStorage.getItem("tipoAgendamiento"),
    };
  },

  methods: {

    crearExpediente() {

      let body={
          "email": sessionStorage.getItem("email"),
          "phone": sessionStorage.getItem("telefono"),
          "scheduling_date": sessionStorage.getItem("fechaAgenda"),
          "scheduling_time": sessionStorage.getItem("horaAgenda"),
          "content": {
              "Make": sessionStorage.getItem("marca"),
              "Model": sessionStorage.getItem("modelo"),
              "Year": sessionStorage.getItem("anio"),
              "Color": sessionStorage.getItem("color"),
              "Milage": sessionStorage.getItem("kilometraje"),
              "Version": sessionStorage.getItem("version"),
              "Folio_Gestor_Precios": sessionStorage.getItem("folio"),
              "Folio_Autocheck": sessionStorage.getItem("idvaloration")
            }
      }

      axios.post(this.server + "/valuacion/crea_expediente", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
     
        console.log("Respuesta -->", JSON.stringify(response.data.data));

        sessionStorage.setItem('expediente', response.data.data[0].expediente_uuid);
        sessionStorage.setItem('tokenExpediente', response.data.data[0].expediente_token);

        this.token=response.data.data[0].expediente_token;
        this.expediente=response.data.data[0].expediente_uuid

      })
      .catch((error) => {
        /*this.modalErrorConexion = true;
        this.mensajeError = 'EACCAL';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);*/
      });

      },

    paginaPrincipal(){
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 150);
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatValue(value) {
      let val = Math.round(value / 100) * 100;
      return val
    },

    prueba(){
      clearTimeout(this.intervalos);
      this.$router.push({ path: "/Reagendamiento?vafolio="+this.folio });
    },

    ofertas(){
      this.ofertaMin = (this.oferta - (this.oferta * .10));
      //this.ofertaMax = (Number(this.oferta) + (this.oferta * .02));
      this.ofertaMax = this.oferta;
    },

    documentacion() {
      sessionStorage.setItem("prev", "inspección")
      setTimeout(() => {
        // window.open('/Documentos');
        this.$router.push({ path: "/Documentos" });
      }, 150);
    },

  },

  created(){
    this.ofertas();
    //this.crearExpediente();
  },

  onMounted(){
    window.scrollTo(0, 0)
  },

  computed: {
    validez(){
      let d=new Date();
      d.setDate(d.getDate()+8);
      let a= d.toLocaleDateString('es-pa').split("/");
      return a[1]+"/"+a[0]+"/"+a[2];
    }
  },

};
</script>
<style>
.mejorOferta {
  display: flex;
  height: 128px;
  background-color: #51555c;
  align-items: center;
  justify-content: center;
}

.mejorOferta h5 {
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700 !important;
  font-size: 40px;
  color: #fff;
}

.mejorOferta h6 {
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  color: #fff;
}

.marcaModelo {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  color: #51555C;
  margin-bottom: 20px;
}

/* .oferta {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 125%;
    color: #E63E19;
    margin-bottom: 16px;
} */

.call-to-action{
  font-family: Nissan Brand;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.19px;
  text-align: center;
  margin-top: 45px;

}

.p-call-to-action{
  font-family: Nissan Brand Regular;
  font-size: 24px;
  font-weight: 400;
  line-height: 32.74px;
  text-align: center;
  color: rgba(105, 105, 105, 1);
  margin-bottom: 30px;
}

.a-call-to-action{
  font-family: Nissan Brand Regular;
  font-size: 24px;
  font-weight: 400;
  line-height: 32.74px;
  text-align: center;
  color:rgba(175, 15, 43, 1);


}

</style>